import { render, staticRenderFns } from "./KharkovOblEnergo.vue?vue&type=template&id=2d4014f6&scoped=true&"
import script from "./KharkovOblEnergo.vue?vue&type=script&lang=js&"
export * from "./KharkovOblEnergo.vue?vue&type=script&lang=js&"
import style0 from "./KharkovOblEnergo.vue?vue&type=style&index=0&id=2d4014f6&prod&lang=css&"
import style1 from "./KharkovOblEnergo.vue?vue&type=style&index=1&id=2d4014f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4014f6",
  null
  
)

export default component.exports